<template>
  <div>
    <v-list-item-title v-if="item.type === 'sign'">{{ item.propertyName }}</v-list-item-title>
    <v-list-item-title v-else>{{ displayName }} <span v-if="item.type === 'contact' && !!item.company"> – {{ item.company }}</span></v-list-item-title>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { capitalize } from 'lodash-es';

export default defineComponent({
  name: 'AssociatedItem',

  props: {
    item: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },
  },

  computed: {
    // Record search names a requirement by its project name, which many
    // requirements don't have; label those by type and key instead of a blank row.
    displayName (): string {
      if (this.item.name) return this.item.name as string;

      return `${capitalize(this.item.type as string)} #${this.item._key}`;
    },
  },
});
</script>
